import React from "react";
import {routService} from "../jwt/_services/clasificator/routService";

export const routProvider = {
    getOptions,
    getItem,
    getItemByActivity
};

async function getOptions(){
    try {
        const udn = localStorage.getItem('selectedUdn') === 'undefined' ? null : JSON.parse( localStorage.getItem('selectedUdn') );

        const listItems = await routService.search(0, 1000, { udn : { id : udn.id } });
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code + '-' + item.name,
                    label: <label>{ item.code.toUpperCase() + ' - '  } <b>{ item.name }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error);
    }
}

async function getItem(id){
    try {
        const item = await routService.getItem(id);
        return (
            {
                id: item.id,
                value: item.code + " - " + item.name,
                label: <div><label>{item.code} - {item.name}</label></div>
            }
        );
    } catch (error) {
        console.log(error);
    }
}

async function getItemByActivity(id){
    try {
        const item = await routService.getRoutByActivity(id);
        if (item.data) {
            return (
                {
                    id: item.data.id,
                    value: item.data.code,
                    label: <div><label>{item.data.code}</label></div>
                }
            );
        }
    } catch (error) {
        console.log(error);
    }
}